module.exports = __webpack_public_path__ + "media/src/images/icons/article_icon-653374c85b5eaf5c86b4d6d5db586199.svg";